module.exports = __webpack_public_path__ + "static/img/jersey2018.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jersey2018.jpg
// module id = yyNe
// module chunks = 0